import React, { FC } from 'react';
import classes from './Guide.module.scss';
import createKTileItem from '../../envs/koenigsburg/createKTileItem';
import { Shape } from '@envclient/envengine/src/envs/koenigsburg/KTile';

const KGuideTileItem: FC<{ tc: string; shape: Shape }> = ({ tc, shape }) => {
  const [tileType, ccsonTileCount] = tc.split(':');
  if (+ccsonTileCount === 0) return null;
  return (
    <div className={classes.tileCont + ' ' + classes[shape]}>
      {createKTileItem(Number(tileType))}
      <div className={classes.label}>x {ccsonTileCount}</div>
    </div>
  );
};

export default KGuideTileItem;
